import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// slices
import generaleReducer from "./slices/generale";
import countryReducer from "./slices/countries";
import ticketReducer from "./slices/ticket";
import reportReducer from "./slices/report";
import walletReducer from "./slices/wallet";
import sendtopupReducer from "./slices/sendtopup";
import sendmoncashReducer from "./slices/sendmoncash";
import remesasReducer from "./slices/remesas";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  remesas: remesasReducer,
  sendtopup: sendtopupReducer,
  sendmoncash: sendmoncashReducer,
  wallet: walletReducer,
  ticket: ticketReducer,
  report: reportReducer,
  generale: generaleReducer,
  country: countryReducer,
});

export { rootPersistConfig, rootReducer };
